/* KB Produktnamen auf Karten (Julien 2026-11-03): Wörter werden nur getrennt,
   wenn sie allein nicht in die Zeile passen, und dann mit Bindestrich.

   CSS kann das nicht unterscheiden: hyphens: auto trennt auch Wörter, die ganz
   in die nächste Zeile passen würden, und manche Browser haben gar kein
   deutsches Trennwörterbuch (dann bricht das Wort ohne Bindestrich um).
   Deshalb steht auf den Namen hyphens: manual (kb-components.css). Dieses
   Skript misst jedes Wort; nur in zu breite Wörter setzt es weiche
   Trennstellen (&shy;) an Silbengrenzen. Der Browser trennt dann genau dort
   und zeigt den Bindestrich. */
(function () {
  'use strict';

  var SHY = '­';
  var VOKAL = /^(aa|ee|oo|ie|ei|ai|au|eu|äu|[aeiouäöüy])$/i;
  /* Mehrbuchstabige Laute, die nie getrennt werden */
  var EINHEIT = /^(sch|ch|ck|ph|qu|th|ie|ei|ai|au|eu|äu|aa|ee|oo)/i;
  /* Konsonantenpaare, die zusammen eine Silbe beginnen (Schneide-brett) */
  var ANLAUT = /^(bl|br|dr|fl|fr|gl|gr|kl|kn|kr|pf|pl|pr|sp|st|tr|zw)$/i;

  /* Häufige Wortteile in Produktnamen: an ihren Grenzen wird bevorzugt
     getrennt (Fleisch-messer statt Flei-schmesser), Silbenstellen direkt
     daneben entfallen. */
  var WORTTEILE = ['ausbeiner', 'messer', 'bretter', 'brett', 'pfannen', 'pfanne', 'presse', 'zange',
    'löffel', 'schäler', 'schleuder', 'pinzette', 'halter', 'wender', 'siebe', 'sieb', 'topf', 'kelle',
    'besen', 'reibe', 'schale', 'platte', 'kanne', 'deckel', 'gabel', 'schaber', 'spatel', 'roller',
    'rolle', 'block', 'stahl', 'eisen', 'filier', 'fleisch', 'fisch', 'gemüse', 'kartoffel', 'salat',
    'braten', 'schneide', 'küchen', 'grill', 'wurst', 'buffet', 'servier', 'trenn', 'wetz', 'guss'];

  function wortgrenzen(wort) {
    var klein = wort.toLowerCase();
    var grenzen = [];
    WORTTEILE.forEach(function (teil) {
      var i = klein.indexOf(teil);
      while (i !== -1) {
        [i, i + teil.length].forEach(function (g) {
          var mitten = /[a-zäöüß]/i.test(wort.charAt(g - 1)) && /[a-zäöüß]/i.test(wort.charAt(g));
          if (mitten && g >= 3 && g <= wort.length - 3 && grenzen.indexOf(g) === -1) grenzen.push(g);
        });
        i = klein.indexOf(teil, i + 1);
      }
    });
    /* Pfanne|n-löffel und Pfannen|löffel: von zwei Nachbarn gilt der hintere */
    grenzen.sort(function (x, y) { return x - y; });
    return grenzen.filter(function (g, i) { return grenzen[i + 1] !== g + 1; });
  }

  function einheiten(wort) {
    var teile = [];
    var i = 0;
    while (i < wort.length) {
      var m = wort.slice(i).match(EINHEIT);
      var len = m ? m[0].length : 1;
      teile.push(wort.slice(i, i + len));
      i += len;
    }
    return teile;
  }

  function istBuchstabe(t) {
    return /^[a-zäöüß]+$/i.test(t);
  }

  /* Trennstellen nach den Grundregeln: Vokal|Konsonant+Vokal, Konsonant|Konsonant,
     Anlaut-Paare bleiben zusammen; nie in den ersten oder letzten drei Zeichen. */
  function trennstellen(wort) {
    var t = einheiten(wort);
    var stellen = [];
    var pos = 0;
    var start = [];
    t.forEach(function (x) { start.push(pos); pos += x.length; });
    for (var i = 1; i < t.length - 1; i++) {
      var vorher = t[i - 1], jetzt = t[i], danach = t[i + 1];
      if (!istBuchstabe(vorher) || !istBuchstabe(jetzt) || !istBuchstabe(danach)) continue;
      var v1 = VOKAL.test(vorher), v2 = VOKAL.test(jetzt), v3 = VOKAL.test(danach);
      var stelle = -1;
      if (v1 && !v2 && v3) stelle = start[i];
      else if (!v1 && !v2 && v3 && !ANLAUT.test(vorher + jetzt)) stelle = start[i];
      else if (v1 && !v2 && !v3 && ANLAUT.test(jetzt + danach) && t[i + 2] && VOKAL.test(t[i + 2])) stelle = start[i];
      /* Vor der Trennstelle muss ein Vokal stehen, sonst entsteht „Sch-neide" */
      var vokalDavor = t.slice(0, i).some(function (x) { return VOKAL.test(x); });
      if (vokalDavor && stelle >= 3 && stelle <= wort.length - 3) stellen.push(stelle);
    }
    return stellen;
  }

  function weich(wort) {
    var grenzen = wortgrenzen(wort);
    var stellen = grenzen.concat(trennstellen(wort).filter(function (s) {
      return grenzen.every(function (g) { return Math.abs(s - g) > 1; });
    })).sort(function (x, y) { return x - y; });
    var aus = '';
    var letzte = 0;
    stellen.forEach(function (s) {
      aus += wort.slice(letzte, s) + SHY;
      letzte = s;
    });
    return aus + wort.slice(letzte);
  }

  function mark(link) {
    if (!link.getClientRects().length) return;
    if (link.dataset.kbText === undefined) link.dataset.kbText = link.textContent;
    var text = link.dataset.kbText;
    var breite = link.parentElement.clientWidth;
    if (!breite) return;

    var mess = document.createElement('span');
    mess.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:0;top:0;';
    link.appendChild(mess);
    var geaendert = false;
    var neu = text.split(/(\s+)/).map(function (teil) {
      if (!teil.trim()) return teil;
      mess.textContent = teil;
      /* 2 px Reserve: Wörter, die nur knapp passen, brach der Browser sonst
         wegen Rundung trotzdem um, dann ohne Bindestrich (Servierzang-e) */
      if (mess.getBoundingClientRect().width <= breite - 2) return teil;
      geaendert = true;
      return weich(teil);
    }).join('');
    mess.remove();

    var soll = geaendert ? neu : text;
    if (link.textContent !== soll) link.textContent = soll;
  }

  function run(root) {
    (root || document).querySelectorAll('.card__heading a').forEach(mark);
  }

  function boot() {
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { run(); });

    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(run, 150);
    });

    /* Nachgeladene Karten (Passt dazu, Filter, Suche) */
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('.card__heading a')) run(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
